import { useEffect, useState } from "react";
import { get } from "lodash";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";
import { RaceProgram, RaceStatusEnum } from "@tvg/ts-types/Race";
import { RACE_STATUS_MAPPER } from "@tvg/amplitude/constants";
import {
  getAccountNumber,
  getBalance,
  getIsLogged,
  getResidenceState
} from "@urp/store-selectors";
import { pageViewGtmEvent } from "../utils/gtm/pageView";

type RaceStatusConsidered = Exclude<
  RaceStatusEnum,
  RaceStatusEnum.MANUALLY_CLOSED | RaceStatusEnum.MANUALLY_OPENED
>;

const usePageViewEventDispatch = (
  currentRace: RaceProgram,
  loading: boolean
) => {
  const location = useLocation();
  const isLogged = useSelector(getIsLogged);
  const accountNumber = useSelector(getAccountNumber);
  const balance = useSelector(getBalance);
  const homeState = useSelector(getResidenceState);
  const [prevRaceId, setPrevRaceId] = useState<string | undefined>(undefined);
  const isFdtv = location.pathname.includes("/live");
  const fdtvChannel =
    isFdtv && location.pathname.includes("TVG2") ? "fdr_tv" : "fdtv_plus";

  const privateBrowser =
    typeof window !== "undefined" &&
    localStorage.getItem("privateMode") === "true"
      ? "Yes"
      : "No";

  const raceNumber = get(currentRace, "raceNumber", "");
  const trackName = get(currentRace, "track.trackName");
  const raceStatusCode = currentRace.status?.code;

  useEffect(() => {
    if (!loading && prevRaceId !== currentRace.id) {
      setTimeout(() => {
        pageViewGtmEvent({
          location,
          accountNumber,
          isLogged,
          balance,
          homeState,
          privateBrowser,
          raceNumber,
          trackName,
          raceStatus:
            RACE_STATUS_MAPPER[raceStatusCode as RaceStatusConsidered] ?? "",
          mtp:
            raceStatusCode === RaceStatusEnum.RACE_OFFICIAL
              ? "resulted"
              : currentRace.mtp?.toString() || "0",
          fdtvType: isFdtv ? fdtvChannel : "non_fdtv"
        });
      }, 1000);

      setPrevRaceId(currentRace.id);
    }
  }, [loading, currentRace.id]);
};

export default usePageViewEventDispatch;
